import { TRACKING_COMPONENTS } from '../../shared/enum/tracking.enum';
import { CMSButton, CMSInput } from '../../shared/model/cms-model';
import { getProperty } from './../../shared/utils/getProperty';
import { CMS_RESPONSE } from './../mock/cms.mock';

export class HeaderModel {
  title_format_1: string;
  title_format_2: string;
  title_format_3: string;

  subtite: string;
  subtitle_format_1: string;
  subtitle_format_2: string;

  documentCPF: CMSInput;
  continueButton: CMSButton;

  constructor(model: any) {
    const titleComplete: string = getProperty(model, 'title');
    const subtitleComplete: string = getProperty(model, 'subtitle');

    this.title_format_1 = this.format(titleComplete, 0, 26);
    this.title_format_2 = this.format(titleComplete, 26, 27);
    this.title_format_3 = this.format(titleComplete, 53, 22);

    this.subtite = subtitleComplete;

    this.subtitle_format_1 = this.format(subtitleComplete, 0, 50);
    this.subtitle_format_2 = this.format(subtitleComplete, 50, 29);

    this.documentCPF = new CMSInput(
      getProperty(
        model,
        'components._onboardingcmc_componente_documento_cpf',
        CMS_RESPONSE.components._onboardingcmc_componente_documento_cpf
      )
    );
    this.documentCPF.eventLabel = TRACKING_COMPONENTS.CPF_INPUT;
    this.continueButton = new CMSButton(
      getProperty(
        model,
        'components._onboardingcmc_componente_open_account',
        CMS_RESPONSE.components._onboardingcmc_componente_open_account
      )
    );
    this.continueButton.eventLabel = TRACKING_COMPONENTS.CONTINUE_BUTTON;
  }

  format(stringName: string, initial: number, length: number) {
    if (stringName) {
      return stringName.substr(initial, length);
    }
  }
}
